module.exports = __webpack_public_path__ + "static/media/bg.9f45db5a.jpg";